/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'logs';
const componentName = 'log-cinematic-section-security';
const prefix = `${moduleName}.${componentName}`;

export const wafLabel = `${prefix}.wafLabel`;
export const icapLabel = `${prefix}.icapLabel`;
export const oneActionLabel = `${prefix}.oneActionLabel`;
export const actionsLabel = `${prefix}.actionsLabel`;
export const oneViolationLabel = `${prefix}.oneViolationLabel`;
export const violationsLabel = `${prefix}.violationsLabel`;

export const ENGLISH = {
    [wafLabel]: 'WAF',
    [icapLabel]: 'ICAP ({0, plural, one{# Action} other{# Actions}}, {1, plural, one{# Violation} other{# Violations}})',
};
